import React from "react";

export default function WhatsAppFAB() {
  return (
    <a
      href="https://wa.me/918287799290"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full flex items-center justify-center shadow-2xl transition-transform hover:scale-110 active:scale-95"
      style={{ backgroundColor: "#25D366" }}
    >
      <svg viewBox="0 0 32 32" width="30" height="30" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 2C8.268 2 2 8.268 2 16c0 2.47.643 4.788 1.766 6.8L2 30l7.4-1.738A13.94 13.94 0 0 0 16 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.6a11.54 11.54 0 0 1-5.88-1.608l-.42-.25-4.394 1.032 1.05-4.28-.275-.44A11.56 11.56 0 0 1 4.4 16C4.4 9.593 9.593 4.4 16 4.4S27.6 9.593 27.6 16 22.407 27.6 16 27.6zm6.34-8.66c-.347-.174-2.055-1.013-2.374-1.129-.318-.116-.55-.174-.782.174-.231.347-.897 1.129-1.1 1.36-.202.232-.405.26-.752.087-.347-.174-1.465-.54-2.79-1.72-1.031-.92-1.727-2.055-1.93-2.402-.202-.347-.022-.535.152-.708.156-.155.347-.405.52-.607.174-.202.231-.347.347-.578.116-.232.058-.435-.029-.607-.087-.174-.782-1.887-1.071-2.584-.282-.679-.569-.587-.782-.597l-.666-.012c-.231 0-.607.087-.925.434-.318.347-1.215 1.187-1.215 2.895s1.244 3.358 1.417 3.59c.174.231 2.449 3.74 5.934 5.244.83.358 1.477.572 1.982.732.833.265 1.591.228 2.19.138.668-.1 2.055-.84 2.346-1.651.29-.812.29-1.508.202-1.651-.087-.145-.318-.232-.666-.406z" />
      </svg>
    </a>
  );
}
